// Widget Scripts
import customTicketButton from './js/widgets/customTicketButton.js';
import * as slideshowEvents from './js/widgets/mainFeature/index.js';
import residentCompanies from './js/widgets/residentCompanies.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';
import * as tier2Section from './js/widgets/tier2Section/index.js';

// Custom Theme Scripts
import './js/localjs.js';

// Aos Library
import AOS from 'aos';
import 'aos/dist/aos.css';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketButton();

  if (globalThis.location.pathname === '/') {
    slideshowEvents.mainSlideshow();
    slideshowEvents.autoEventFeed();
    tier2Section.mainCards();
    tier2Section.seoBlock();

    $(globalThis).on('load', function () {
      tier2Section.videoWidget();
      tier2Section.animateSocialSection();

      AOS.init({
        anchorPlacement: 'bottom-bottom',
        animatedClassName: 'aos-animate',
        initClassName: 'aos-init',
      });
    });

    residentCompanies();
    scrollerSponsors();
  }
});
